import React from "react";
// import emailjs from "emailjs-com";
import Icons from "../Common/IconsGroup";
import "./../Styles.css";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
// const LINKS = [
//   {
//     title: { key: "home", label: "Home" },
//     navigation: "/",
//     links: [
//       { key: "goal", label: "Our Goal" },
//       { key: "help", label: "Who We Help" },
//       { key: "tradition", label: "Our Tradition" },
//       { key: "partner", label: "Partners" },
//     ],
//   },
//   {
//     title: { key: "solution", label: "Solutions" },
//     navigation: "/solutions",
//     links: [
//       { key: "features", label: "Features" },
//       { key: "steps", label: "Work Flow" },
//       { key: "energyCost", label: "Savings" },
//       { key: "energyCalculation", label: "Energy Spend Calculator" },
//     ],
//   },
//   {
//     title: { key: "about", label: "About Utvyakta" },
//     navigation: "/aboutus",
//     links: [
//       { key: "advisors", label: "Advisors" },
//       { key: "achivements", label: "Achivements" },
//       { key: "leadership", label: "Leadership" },
//       { key: "coreTeam", label: "Team" },
//     ],
//   },
// ];

function Footer({ pageRefs }) {
  const navigate = useNavigate();
  // const [success, setSuccess] = useState(false);

  // function sendEmail(event) {
  //   event.preventDefault();

  //   emailjs
  //     .sendForm(
  //       "service_pr1xj5h",
  //       "template_wz9rurg",
  //       event.target,
  //       "user_KRu5oKGj1miFTJBXT5toF"
  //     )
  //     .then(
  //       (result) => {
  //         document.getElementById("myForm").reset();
  //         setSuccess(true);
  //         setTimeout(() => {
  //           setSuccess(false);
  //         }, 3000);
  //       },
  //       (error) => {
  //         document.getElementById("myForm").reset();
  //       }
  //     );
  // }

  const handleTheScrollView = (scrollTo, path) => {
    let ref = pageRefs?.[scrollTo];
    if (ref?.current) {
      const y =
        ref.current.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      navigate(path, { state: { scrollTo: scrollTo } });
    }
  };

  return (
    <div className="footer-container">
      <div className="footer-child-container">
        <div className="footer-img-container">
          <img src={require("./../images/utv_white_logo.svg").default} alt="" />
          <div className="footer-img-content-1">
            <span className="footer-img-content-1-bold">Headquarters: </span>
            Coimbatore, India
          </div>
          <div className="footer-img-content-2 footer-img-content-2-bold">
            Other Locations:
          </div>
          <div className="footer-img-content-2">
            Bangalore, Ahmedabad, Delhi NCR, India
          </div>
          <div className="linkedin-icon">
            <a
              href="https://www.linkedin.com/company/utvyakta-solutions-private-limited/" target="_blank" rel="noopener noreferrer">
              {Icons(20, 20, "#ffffffff").Linkedin()}
            </a>
          </div>
        </div>
        <div className="footer-links-container">
          <span className="footer-link-header">Home</span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("platform", "/")}
          >
            Platform
          </span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("works", "/")}
          >
            Integration
          </span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("solutions", "/")}
          >
            Solutions
          </span>
          {/* <span className="footer-link" onClick={() => handleTheScrollView()}>Multi-site Management</span> */}
        </div>
        <div className="footer-links-container">
          <span className="footer-link-header">Intelligence</span>
          <span
            className="footer-link"
            onClick={() =>
              handleTheScrollView("solutionbanner", "/intelligence")
            }
          >
            Energy Intelligence
          </span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("carbon", "/intelligence")}
          >
            Carbon Tracking
          </span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("prediction", "/intelligence")}
          >
            Predictive Maintenance
          </span>
          {/* <span className="footer-link" onClick={() => handleTheScrollView("banner", "/intelligence")}>IoT Integration</span> */}
        </div>
        <div className="footer-links-container">
          <span className="footer-link-header">Company</span>
          <span
            className="footer-link"
            onClick={() => handleTheScrollView("aboutbanner", "/aboutus")}
          >
            About Us
          </span>
          <span
            className="footer-link"
            onClick={() => {
              window.location.href = "mailto:sales@utvyakta.com";
            }}
          >
            Contact
          </span>
          {/* <span className="footer-link" onClick={() => handleTheScrollView()}>Support</span> */}
          <span className="footer-link" onClick={() => navigate("/privacy")}>
            Privacy Policy
          </span>
        </div>
      </div>
      <div className="footer-copy-right">
        <p>
          &copy; 2024 Kompress.ai by Utvyakta Solutions. All rights reserved.
        </p>
      </div>
    </div>
  );

  // return (
  //   <div className="footer-section">
  //   <div className="footer-content">
  //     <div className="footer-branding">
  //       <img
  //         src={require("./../images/utv_white_logo.svg").default}
  //         alt="Utvyakta Logo"
  //         className="footer-logo"
  //       />
  //       <p className="footer-desc">
  //         Revolutionizing compressed air monitoring and optimization with intelligent, data-driven insights.
  //       </p>
  //       <div className="footer-social">
  //         <a href="https://twitter.com/utvyakta" target="_blank" rel="noreferrer">
  //           <img src={require("./../images/twitter.png")} alt="Twitter" />
  //         </a>
  //         <a
  //           href="https://www.linkedin.com/company/utvyakta-solutions-private-limited/"
  //           target="_blank"
  //           rel="noreferrer"
  //         >
  //           <img src={require("./../images/in.png")} alt="LinkedIn" />
  //         </a>
  //         <a href="https://www.facebook.com/utvyakta/" target="_blank" rel="noreferrer">
  //           <img src={require("./../images/facebook.png")} alt="Facebook" />
  //         </a>
  //       </div>
  //     </div>

  //     <div className="footer-links-grid">
  //       {LINKS.map((section, i) => (
  //         <div key={i} className="footer-column">
  //           <h4>{section.title.label}</h4>
  //           <ul>
  //             {section.links.map((link, j) => (
  //               <li key={j} onClick={() => handleTheScrollView(link.key, section.navigation)}>
  //                 {link.label}
  //               </li>
  //             ))}
  //           </ul>
  //         </div>
  //       ))}
  //       <div className="footer-column subscribe-column">
  //         <h4>Stay Updated</h4>
  //         <p>Get insights and updates from Utvyakta</p>
  //         <form onSubmit={sendEmail} id="myForm" className="subscribe-form">
  //           <input type="email" name="email" placeholder="Your email address" required />
  //           <button type="submit">Subscribe</button>
  //         </form>
  //         {success && <p className="subscribe-success">Subscribed successfully.</p>}
  //       </div>
  //     </div>
  //   </div>

  //   <div className="footer-divider"></div>

  //   <div className="footer-bottom">
  //     <div className="footer-locations">
  //       <div>
  //         <h5>Sweden</h5>
  //         <p>Kommendörsgatan 11<br />114 48 Stockholm</p>
  //       </div>
  //       <div>
  //         <h5>India</h5>
  //         <p>
  //           425 Mettupalayam Rd, Tatabad, Coimbatore<br />
  //           <a href="mailto:sales@utvyakta.com">sales@utvyakta.com</a><br />
  //           <a href="tel:+919843240322">+91 98432 40322</a>
  //         </p>
  //       </div>
  //       <div>
  //         <h5>USA</h5>
  //         <p>5500 Trabuco Rd Suite 150<br />Irvine, CA 92620</p>
  //       </div>
  //     </div>
  //     <div className="footer-legal">
  //       <a href="/privacy">Privacy & Cookie Policy</a>
  //       <p>© 2021–2025 Utvyakta Solutions Pvt. Ltd. All Rights Reserved.</p>
  //     </div>
  //   </div>
  // </div>

  // )

  // return(
  //   <React.Fragment>
  //     <div className="container-fluid utv_footer">
  //       <div className="container">
  //         <div className="footer-header-container">
  //           <img
  //               alt=""
  //               src={require("./../images/utv_white_logo.svg").default}
  //               className="footer-logo-img"
  //             />
  //           <div className="footer-header-section">
  //             <span className="footer-header-title">Contact Us</span>
  //             <span className="footer-header-sub-title">
  //               Get in touch to start your compressed air optimization journey
  //             </span>
  //           </div>
  //         </div>

  //         <div className="footer-address-links-container">
  //           <div className="footer-links-subscribe-container">

  //           <div className="footer-links-container">
  //               {LINKS.map((data) => {
  //                 let navTo = data.navigation;
  //                 return (
  //                 <div className="footer-links-content-container">
  //                 <span className="footer-links-content-title" onClick={() => handleTheScrollView(data.title.key, navTo)}>
  //                   {data.title.label}
  //                 </span>
  //                 <div className="footer-links-content-sub-contents">
  //                   {
  //                     data.links.map((linkObj) => {
  //                       return (
  //                         <span className="footer-links-content-sub-title" onClick={() => handleTheScrollView(linkObj.key, navTo)}>{linkObj.label}</span>
  //                       )
  //                     })
  //                   }
  //                   </div>
  //               </div>
  //               )
  //               })}
  //             </div>
  //             <div className="">
  //               <div className="footer-subscribe-container">
  //                 <div>
  //                 <h2 className="sub-heading white-text footer-subscriber-button">Subscribe</h2>
  //                 <p className="para footer-subscriber-sub-content">Stay current with our latest insights</p>
  //                 </div>
  //                 <div className="">
  //                 <a
  //                   href="https://twitter.com/utvyakta"
  //                   target="_blank"
  //                   rel="noopener noreferrer"
  //                   className="twitter-icon"
  //                 >
  //                   <img className="footer-social-icon" alt="" src={require("./../images/twitter.png")} />
  //                 </a>
  //                 <a
  //                   href="https://www.linkedin.com/company/utvyakta-solutions-private-limited/"
  //                   target="_blank"
  //                   rel="noopener noreferrer"
  //                 >
  //                   <img className="footer-social-icon" alt="" src={require("./../images/in.png")} />
  //                 </a>
  //                 <a href="https://www.facebook.com/utvyakta/" target="_blank" rel="noopener noreferrer">
  //                   <img className="footer-social-icon" alt="" src={require("./../images/facebook.png")} />
  //                 </a>
  //               </div>
  //               </div>

  //             <form
  //               className="row g-3"
  //               id="myForm"
  //               style={{ position: "relative" }}
  //               onSubmit={sendEmail}
  //             >
  //               <div className="col-auto">
  //                 <div className="subscribe-input-conatiner">
  //                   <div>
  //                     <input
  //                       type="text"
  //                       name="email"
  //                       className="subscribe-textbox subscribe-input"
  //                       required
  //                     />
  //                   </div>
  //                   <div className="">
  //                     <button type="submit" className="pink-btn subscribe-btn subscribe-button">
  //                       Subscribe
  //                     </button>
  //                   </div>
  //                 </div>

  //                 <div className="row">
  //                   {success && (
  //                     <div className="col-12 success-subscribe">
  //                       Subscribed successfully.
  //                     </div>
  //                   )}
  //                 </div>
  //               </div>

  //             </form>
  //           </div>
  //             </div>
  //             <div className="footer-address-container">
  //               <div className="">
  //                 <p className="para footer-address-text">
  //                   Kommendörsgatan 11 <br /> 114 48 Stockholm SWEDEN
  //                 </p>
  //               </div>
  //               <div className="">
  //                 <p className="para footer-address-text">
  //                   425 Mettupalayam Rd Tatabad, <br /> Coimbatore, Tamil Nadu
  //                   641043. INDIA
  //                   <br /><i className="fa fa-envelope"></i>&nbsp;
  //                   <a className="para footer-address-text" href="mailto:sales@utvyakta.com">sales@utvyakta.com</a>
  //                   <br /><i className="fa fa-phone"></i>&nbsp;
  //                   <a className="para footer-address-text" href="tel:+919843240322">+919843240322</a>
  //                 </p>
  //               </div>
  //               <div className="">
  //                 <p className="para footer-address-text">
  //                   5500 Trabuco Rd Suite 150 <br />
  //                   Irvine, California, 92620 <br /> United States of America
  //                 </p>
  //               </div>
  //             </div>

  //         </div>

  //         <div className="row">
  //           <div className="col-md-8">
  //             {/* <img
  //               alt=""
  //               src={require("./../images/utv_white_logo.svg").default}
  //               width="250px"
  //               style={{ marginLeft: "-20px" }}
  //             /> */}
  //             {/* <div className="footer-links-container">
  //               {LINKS.map((data) => {
  //                 let navTo = data.navigation;
  //                 return (
  //                 <div className="footer-links-content-container">
  //                 <span className="footer-links-content-title" onClick={() => handleTheScrollView(data.title.key, navTo)}>
  //                   {data.title.label}
  //                 </span>
  //                 <div className="footer-links-content-sub-contents">
  //                   {
  //                     data.links.map((linkObj) => {
  //                       return (
  //                         <span className="footer-links-content-sub-title" onClick={() => handleTheScrollView(linkObj.key, navTo)}>{linkObj.label}</span>
  //                       )
  //                     })
  //                   }
  //                   </div>
  //               </div>
  //               )
  //               })}
  //             </div> */}
  //             {/* <div className="row " style={{ paddingTop: "20px" }}>
  //               <div className="col-md-3 borderRight borderBottom">
  //                 <p className="para">
  //                   Kommendörsgatan 11 <br /> 114 48 Stockholm SWEDEN
  //                 </p>
  //               </div>
  //               <div className="col-md-4 borderRight borderBottom">
  //                 <p className="para">
  //                   425 Mettupalayam Rd Tatabad, <br /> Coimbatore, Tamil Nadu
  //                   641043. INDIA
  //                   <br /><i className="fa fa-envelope"></i>&nbsp;
  //                   <a className="para" href="mailto:sales@utvyakta.com">sales@utvyakta.com</a>
  //                   <br /><i className="fa fa-phone"></i>&nbsp;
  //                   <a className="para" href="tel:+919843240322">+919843240322</a>
  //                 </p>
  //               </div>
  //               <div className="col-md-4  borderBottom">
  //                 <p className="para">
  //                   5500 Trabuco Rd Suite 150 <br />
  //                   Irvine, California, 92620 <br /> United States of America
  //                 </p>
  //               </div>
  //             </div> */}

  //             <div className="">
  //               <div className="footer-policy-link-container">
  //                 {/* <ul className=""> */}
  //                   {/* <li> */}
  //                     <a href="/privacy" className="footer-privacy-content">Privacy Policy & Cookie Policy</a>
  //                     <span className="footer-privacy-content">Copyright 2021-2024 Utvyakta Solutions (P) Ltd., All Rights
  //                 Reserved.</span>
  //                   {/* </li> */}
  //                   {/* <li><a href="#">Terms of use</a></li>
  //                           <li><a href="#">Local language information</a></li>
  //                           <li><a href="#">Accessibility Statement</a></li> */}
  //                 {/* </ul> */}
  //               </div>
  //             </div>

  //             {/* <div className="row">
  //               <div className="col-12 footer-privacy-content">
  //                 Copyright 2021-2024 Utvyakta Solutions (P) Ltd., All Rights
  //                 Reserved.
  //               </div>
  //             </div> */}
  //           </div>
  //           {/* <div className="col-md-4" style={{ paddingTop: "50px" }}>
  //             <h2 className="sub-heading white-text">Subscribe</h2>
  //             <p className="para">Stay current with our latest insights</p>

  //             <form
  //               className="row g-3"
  //               id="myForm"
  //               style={{ position: "relative" }}
  //               onSubmit={sendEmail}
  //             >
  //               <div className="col-auto">
  //                 <div className="row">
  //                   <div className="col-md-7">
  //                     <input
  //                       type="text"
  //                       name="email"
  //                       className="subscribe-textbox"
  //                       style={{ width: "250px" }}
  //                       required
  //                     />
  //                   </div>
  //                   <div className="col-md-5">
  //                     <button type="submit" className="pink-btn subscribe-btn">
  //                       Subscribe
  //                     </button>
  //                   </div>
  //                 </div>

  //                 <div className="row">
  //                   {success && (
  //                     <div className="col-12 success-subscribe">
  //                       Subscribed successfully.
  //                     </div>
  //                   )}
  //                 </div>
  //               </div>
  //               <div className="footer-social-icons">
  //                 <a
  //                   href="https://twitter.com/utvyakta"
  //                   target="_blank"
  //                   rel="noopener noreferrer"
  //                   className="twitter-icon"
  //                 >
  //                   <img alt="" src={require("./../images/twitter.png")} />
  //                 </a>
  //                 <a
  //                   href="https://www.linkedin.com/company/utvyakta-solutions-private-limited/"
  //                   target="_blank"
  //                   rel="noopener noreferrer"
  //                 >
  //                   <img alt="" src={require("./../images/in.png")} />
  //                 </a>
  //                 <a href="https://www.facebook.com/utvyakta/" target="_blank" rel="noopener noreferrer">
  //                   <img alt="" src={require("./../images/facebook.png")} />
  //                 </a>
  //               </div>
  //             </form>
  //           </div> */}
  //         </div>
  //       </div>
  //     </div>
  //   </React.Fragment>
  // );
}

export default Footer;
